import React from "react";
import "./palam_button_big_round.scss";

class PalamButtonBigRound extends React.PureComponent {
  render() {
    let { children, label = "", size, color, ...rest } = this.props;
    let sizingStyle = {}
    if (size) {
        sizingStyle = {width: size+"px", height: size+"px"}
    }
    let colorStyle = {borderColor: color};
    return (
      <div className="palam-button-big-round-wrapper">
        <button className="circle" style={{...sizingStyle, ...colorStyle}} {...rest}>
          {children}
        </button>
        {label !== "" && (
          <p className="label">{label}</p>
        )}
      </div>
    );
  }
}

export default PalamButtonBigRound;
